//#region IMPORTS
import {
  setInstoreTypeParams,
  clearInstoreTypeParam,
  clearInstoreTypeParams,
} from "../../features/instoreTypes/instoreTypesSlice";
import { useAppDispatch, useAppSelector } from "../../store/configureStore";
import { ReactNode } from "react";
import MainFilterBarItem from "../_layout/MainFilterBarItem";
import MainFilterBar from "../_layout/MainFilterBar";
//#endregion

//#region INTERFACE
interface Props {
  extensionButtons?: ReactNode;
}
//#endregion

export default function InstoreTypesFilterBar({ extensionButtons }: Props) {
  //#region SETUP
  // Redux
  const dispatch = useAppDispatch();
  const { page, limit, sort, ...params } = useAppSelector(
    ({ instoreTypes }) => instoreTypes.instoreType_params
  );
  const { loading } = useAppSelector(({ instoreTypes }) => instoreTypes);
  //#endregion

  //#region RENDER
  return (
    <MainFilterBar
      paramNamesList={params}
      clearAllFiltersHandler={() => dispatch(clearInstoreTypeParams())}
      extensionButtons={extensionButtons}
      clearFilterHandler={(paramName: string) => {
        dispatch(clearInstoreTypeParam(paramName));
      }}
      disabled={loading}
    >
      {/* name */}
      <MainFilterBarItem
        filterParameterName="name"
        displayExplanation="Search the instore types by name"
        clearFilterAction={() => dispatch(clearInstoreTypeParam("name"))}
        selectedValue={params.name}
        filterAction={(value: string) =>
          dispatch(setInstoreTypeParams({ name: value }))
        }
        displayText="Type name"
        selected={!!params.name}
      />
    </MainFilterBar>
  );
  //#endregion
}
